import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";
import { getApiData } from "../../../../../helpers/AxiosInstance";
import APIS from "../../../../../constant/Endpoint";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("footer", {
    isComponent: (el) => {
      if (
        el.tagName === "FORM" &&
        el.className?.toString().includes("news-letter")
      ) {
        return { type: "footer" };
      }
    },
    model: {
      defaults: {
        attributes: { class: "footer" },
        components: html`
          <footer id="footer-style" class="bg-gray-50 pt-8 pb-4 text-gray-700">
            <section
              class="container mx-auto grid grid-cols-1 md:grid-cols-6 gap-6 px-4"
            >
              <div class="col-span-1 md:col-span-2 flex flex-col space-y-4">
                <img
                  id="footerLogo"
                  class="w-20 h-auto"
                  src="https://via.placeholder.com/100"
                  alt="Logo"
                />
                <p>
                  Your One-Stop Shop for <br />
                  Every Occasion
                </p>
                <p class="font-semibold text-lg">Stay upto date</p>
                <form class="flex items-center space-x-2  news-letter">
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    required
                    class="w-full max-w-[260px] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-gray-200"
                  />
                  <button
                    type="submit"
                    class="px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-900"
                  >
                    Subscribe
                  </button>
                </form>
              </div>
              <div>
                <h3 class="text-lg font-semibold">Explore</h3>
                <ul class="space-y-2">
                  <li><a href="#" class="hover:underline">Home</a></li>
                  <li><a href="#" class="hover:underline">Shop</a></li>
                  <li><a href="#" class="hover:underline">Blog</a></li>
                  <li><a href="#" class="hover:underline">Sale</a></li>
                </ul>
              </div>
              <div>
                <h3 class="text-lg font-semibold">Categories</h3>
                <ul class="space-y-2">
                  <li><a href="#" class="hover:underline"> Men's Wear </a></li>
                  <li>
                    <a href="#" class="hover:underline">Women's Wear</a>
                  </li>
                  <li><a href="#" class="hover:underline">Kid's Wear</a></li>
                  <li><a href="#" class="hover:underline">Gym Wear</a></li>
                  <li><a href="#" class="hover:underline">Home Decor</a></li>
                </ul>
              </div>
              <div>
                <h3 class="text-lg font-semibold">Legal</h3>
                <ul class="space-y-2">
                  <li>
                    <a href="#" class="hover:underline">Terms and Conditions</a>
                  </li>
                  <li>
                    <a href="#" class="hover:underline">Privacy Policy</a>
                  </li>
                </ul>
              </div>
              <div>
                <h3 class="text-lg font-semibold">Contact Us</h3>
                <ul class="space-y-2">
                  <li>
                    <a
                      href="tel:+977-9705556056"
                      class="flex items-center gap-x-2 hover:underline"
                    >
                      <svg
                        width="14"
                        height="16"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.23 12.8022L13.69 12.5122C13.3914 12.4772 13.0887 12.5102 12.8046 12.609C12.5206 12.7077 12.2626 12.8695 12.05 13.0822L10.21 14.9222C7.37144 13.4782 5.0641 11.1709 3.62004 8.33225L5.47004 6.48225C5.90004 6.05225 6.11004 5.45225 6.04004 4.84225L5.75004 2.32225C5.69356 1.83434 5.45951 1.38427 5.0925 1.05784C4.7255 0.731412 4.25121 0.551446 3.76004 0.552249H2.03004C0.900041 0.552249 -0.0399594 1.49225 0.0300407 2.62225C0.560041 11.1622 7.39004 17.9822 15.92 18.5122C17.05 18.5822 17.99 17.6422 17.99 16.5122V14.7822C18 13.7722 17.24 12.9222 16.23 12.8022Z"
                          fill="currentColor"
                        />
                      </svg>
                      <span>+977-9705556056</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      class="flex items-center gap-x-2 hover:underline"
                    >
                      <svg
                        width="14"
                        height="16"
                        viewBox="0 0 14 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7 10.043C6.33696 10.043 5.70107 9.77958 5.23223 9.31074C4.76339 8.84189 4.5 8.20601 4.5 7.54297C4.5 6.87993 4.76339 6.24404 5.23223 5.7752C5.70107 5.30636 6.33696 5.04297 7 5.04297C7.66304 5.04297 8.29893 5.30636 8.76777 5.7752C9.23661 6.24404 9.5 6.87993 9.5 7.54297C9.5 7.87127 9.43534 8.19636 9.3097 8.49968C9.18406 8.80299 8.99991 9.07859 8.76777 9.31074C8.53562 9.54288 8.26002 9.72703 7.95671 9.85267C7.65339 9.9783 7.3283 10.043 7 10.043ZM7 0.542969C5.14348 0.542969 3.36301 1.28047 2.05025 2.59322C0.737498 3.90598 0 5.68645 0 7.54297C0 12.793 7 20.543 7 20.543C7 20.543 14 12.793 14 7.54297C14 5.68645 13.2625 3.90598 11.9497 2.59322C10.637 1.28047 8.85652 0.542969 7 0.542969Z"
                          fill="currentColor"
                        />
                      </svg>
                      <span>Kathmandu, Nepal</span>
                    </a>
                  </li>
                </ul>
              </div>
            </section>
            <hr class="mt-6 border-gray-200" />
            <div
              class=" pt-4 px-4 container mx-auto flex flex-col md:flex-row  justify-between items-center"
            >
              <p class="text-center text-base">© 2024 collectionnepal.com</p>
              <div
                class="flex md:flex-row  items-center justify-center space-x-4"
              >
                <span class=" font-semibold">Follow us on:</span>
                <a href="#" class="hover:text-blue-500 p-2">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M28.0002 15.5415C28.0002 8.6415 22.4002 3.0415 15.5002 3.0415C8.6002 3.0415 3.0002 8.6415 3.0002 15.5415C3.0002 21.5915 7.3002 26.629 13.0002 27.7915V19.2915H10.5002V15.5415H13.0002V12.4165C13.0002 10.004 14.9627 8.0415 17.3752 8.0415H20.5002V11.7915H18.0002C17.3127 11.7915 16.7502 12.354 16.7502 13.0415V15.5415H20.5002V19.2915H16.7502V27.979C23.0627 27.354 28.0002 22.029 28.0002 15.5415Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
                <a href="#" class="hover:text-blue-500 p-2">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.7854 3.0415C18.1916 3.04525 18.9054 3.05275 19.5216 3.07025L19.7641 3.079C20.0441 3.089 20.3204 3.1015 20.6541 3.1165C21.9841 3.179 22.8916 3.389 23.6879 3.69775C24.5129 4.01525 25.2079 4.44525 25.9029 5.139C26.5387 5.76367 27.0306 6.51959 27.3441 7.354C27.6529 8.15025 27.8629 9.05775 27.9254 10.389C27.9404 10.7215 27.9529 10.9978 27.9629 11.279L27.9704 11.5215C27.9891 12.1365 27.9966 12.8503 27.9991 14.2565L28.0004 15.189V16.8265C28.0034 17.7383 27.9938 18.65 27.9716 19.5615L27.9641 19.804C27.9541 20.0853 27.9416 20.3615 27.9266 20.694C27.8641 22.0253 27.6516 22.9315 27.3441 23.729C27.0306 24.5634 26.5387 25.3193 25.9029 25.944C25.2782 26.5799 24.5223 27.0717 23.6879 27.3853C22.8916 27.694 21.9841 27.904 20.6541 27.9665L19.7641 28.004L19.5216 28.0115C18.9054 28.029 18.1916 28.0378 16.7854 28.0403L15.8529 28.0415H14.2166C13.3045 28.0447 12.3923 28.0351 11.4804 28.0128L11.2379 28.0053C10.9411 27.994 10.6445 27.9811 10.3479 27.9665C9.01788 27.904 8.11038 27.694 7.31288 27.3853C6.47891 27.0716 5.72343 26.5797 5.09913 25.944C4.46281 25.3195 3.97051 24.5635 3.65663 23.729C3.34788 22.9328 3.13788 22.0253 3.07538 20.694L3.03788 19.804L3.03163 19.5615C3.00858 18.65 2.99817 17.7383 3.00038 16.8265V14.2565C2.99692 13.3448 3.00608 12.433 3.02788 11.5215L3.03663 11.279C3.04663 10.9978 3.05913 10.7215 3.07413 10.389C3.13663 9.05775 3.34663 8.1515 3.65538 7.354C3.96999 6.51925 4.46315 5.7633 5.10038 5.139C5.72432 4.50344 6.47936 4.0116 7.31288 3.69775C8.11038 3.389 9.01663 3.179 10.3479 3.1165C10.6804 3.1015 10.9579 3.089 11.2379 3.079L11.4804 3.0715C12.3919 3.04929 13.3036 3.03971 14.2154 3.04275L16.7854 3.0415ZM15.5004 9.2915C13.8428 9.2915 12.2531 9.94998 11.081 11.1221C9.90886 12.2942 9.25038 13.8839 9.25038 15.5415C9.25038 17.1991 9.90886 18.7888 11.081 19.9609C12.2531 21.133 13.8428 21.7915 15.5004 21.7915C17.158 21.7915 18.7477 21.133 19.9198 19.9609C21.0919 18.7888 21.7504 17.1991 21.7504 15.5415C21.7504 13.8839 21.0919 12.2942 19.9198 11.1221C18.7477 9.94998 17.158 9.2915 15.5004 9.2915ZM15.5004 11.7915C15.9928 11.7914 16.4805 11.8883 16.9355 12.0767C17.3905 12.2651 17.8039 12.5413 18.1522 12.8894C18.5005 13.2376 18.7768 13.6509 18.9653 14.1059C19.1538 14.5608 19.2509 15.0484 19.251 15.5409C19.2511 16.0333 19.1542 16.521 18.9658 16.976C18.7774 17.431 18.5013 17.8444 18.1531 18.1927C17.8049 18.541 17.3916 18.8173 16.9366 19.0058C16.4817 19.1943 15.9941 19.2914 15.5016 19.2915C14.5071 19.2915 13.5532 18.8964 12.85 18.1932C12.1467 17.4899 11.7516 16.5361 11.7516 15.5415C11.7516 14.5469 12.1467 13.5931 12.85 12.8899C13.5532 12.1866 14.5071 11.7915 15.5016 11.7915M22.0641 7.4165C21.6497 7.4165 21.2523 7.58112 20.9593 7.87415C20.6662 8.16718 20.5016 8.5646 20.5016 8.979C20.5016 9.3934 20.6662 9.79083 20.9593 10.0839C21.2523 10.3769 21.6497 10.5415 22.0641 10.5415C22.4785 10.5415 22.876 10.3769 23.169 10.0839C23.462 9.79083 23.6266 9.3934 23.6266 8.979C23.6266 8.5646 23.462 8.16718 23.169 7.87415C22.876 7.58112 22.4785 7.4165 22.0641 7.4165Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
                <a href="#" class="hover:text-blue-500 p-2">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M28.575 8.04199C27.6125 8.47949 26.5751 8.76699 25.5 8.90449C26.6 8.24199 27.4501 7.19199 27.8501 5.92949C26.8126 6.55449 25.6625 6.99199 24.4501 7.24199C23.4625 6.16699 22.0751 5.54199 20.5001 5.54199C17.5626 5.54199 15.1625 7.94199 15.1625 10.9045C15.1625 11.3295 15.2126 11.742 15.3001 12.1295C10.85 11.9045 6.88755 9.76699 4.25005 6.52949C3.78755 7.31699 3.52505 8.24199 3.52505 9.21699C3.52505 11.0795 4.46255 12.7295 5.91255 13.667C5.02505 13.667 4.20005 13.417 3.47505 13.042V13.0795C3.47505 15.6795 5.32505 17.8545 7.77505 18.342C6.9886 18.5582 6.1626 18.5881 5.36255 18.4295C5.70206 19.4951 6.36697 20.4275 7.26382 21.0957C8.16067 21.7638 9.24436 22.1341 10.3625 22.1545C8.46714 23.6551 6.11756 24.4662 3.70005 24.4545C3.27505 24.4545 2.85005 24.4295 2.42505 24.3795C4.80005 25.9045 7.62505 26.792 10.65 26.792C20.5001 26.792 25.9126 18.617 25.9126 11.5295C25.9126 11.292 25.9125 11.067 25.9 10.8295C26.9501 10.0795 27.85 9.12949 28.575 8.04199Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
                <a href="#" class="hover:text-blue-500 p-2">
                  <svg
                    fill="currentColor"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    xml:space="preserve"
                  >
                    <path
                      d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 0 1 3.183-4.51v-3.5a6.329 6.329 0 0 0-5.394 10.692 6.33 6.33 0 0 0 10.857-4.424V8.687a8.182 8.182 0 0 0 4.773 1.526V6.79a4.831 4.831 0 0 1-1.003-.104z"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </footer>
        `,
        toolbar: [
          {
            attributes: { class: "fa fa-trash-o" },
            command: "tlb-delete",
          },
          {
            attributes: { class: "fa fa-gear" },
            command: "footer-edit",
          },
        ],
        script: function () {
          const newsLetterForm = document.querySelector(
            ".news-letter"
          ) as HTMLFormElement;
          const formType = newsLetterForm.getAttribute("form-type");

          const showToast = function (toastMessage, color) {
            //@ts-ignore
            Toastify({
              text: `${toastMessage}`,
              duration: 2000,
              close: false,
              gravity: "top",
              position: "right",
              stopOnFocus: true,
              offset: {
                x: 20,
                y: 60,
              },
              style: {
                background: `${color}`,
              },
            }).showToast();
          };

          newsLetterForm.addEventListener("submit", function (event) {
            event.preventDefault();
            const formData = new FormData(newsLetterForm);
            let formObject = {};
            formData.forEach(function (value, key) {
              formObject[key] = value;
            });
            fetch("{% url 'save_form' %}", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                form_data: formObject,
                form: formType,
              }),
            })
              .then((response) => {
                if (!response.ok) {
                  return response.json().then((errorData) => {
                    throw new Error(
                      errorData.message || "Something went wrong"
                    );
                  });
                }
                return response.json();
              })
              .then((result) => {
                newsLetterForm.reset();
                showToast("Success", "green");
              })
              .catch((error) => {
                console.error("Error adding product to cart:", error);
              });
          });
        },
      },
      async init() {
        this.loadTraitOptions();
      },
      async loadTraitOptions() {
        const formResponse = await getApiData(APIS.FORMS, {});
        const tag = this.get("tagName");
        if (tag === "form") {
          this.set("traits", [
            {
              type: "select",
              label: "Select form",
              name: "form-type",
              options: formResponse?.data ?? [],
            },
          ]);
        }
      },
    },
  });
};
